"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayToRecord = exports.getUniqueObjectsByProperyName = exports.getUniqueObjectsWithAccessor = void 0;
function getUniqueObjectsWithAccessor(array, accessor) {
    const flags = new Set;
    return array.filter(function (entry) {
        if (flags.has(accessor(entry))) {
            return false;
        }
        flags.add(accessor(entry));
        return true;
    });
}
exports.getUniqueObjectsWithAccessor = getUniqueObjectsWithAccessor;
function getUniqueObjectsByProperyName(array, propertyName) {
    return getUniqueObjectsWithAccessor(array, (v) => v[propertyName]);
}
exports.getUniqueObjectsByProperyName = getUniqueObjectsByProperyName;
function arrayToRecord(array, keyAccessor) {
    const res = {};
    array.forEach((object, index) => {
        const key = keyAccessor ? keyAccessor(object) : String(index);
        res[key] = object;
    });
    return res;
}
exports.arrayToRecord = arrayToRecord;
//# sourceMappingURL=arrays.js.map